import Vue from 'vue';
import Router from 'vue-router';
import 'amfe-flexible';

import App from './App.vue';
import store from '@/store';
import router from '@/router';
import VueMeta from 'vue-meta';

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
import '@/styles/common.scss';
import '@/styles/animate.css';

import { Lazyload } from 'vant';
Vue.config.productionTip = false;
Vue.use(Lazyload);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
